<template>
  <title-banner :title="titleBanner"/>
  <div class="bg-gray-100 min-h-screen">
    <header class="bg-blue-600 text-white p-6 shadow-md mb-6 bg-cover bg-center"
            :style="{ backgroundImage: `url(${image})` }">
      <h1 class="text-2xl font-bold m-auto w-[70%]">{{ program_name }}</h1>
      <p class="mt-2 text-sm m-auto w-[70%]">
        {{ program_description }}
      </p>
    </header>

    <main class="xl:w-[70%] lg:w-[75%] md:w-[80%] m-auto">
      <div class="flex justify-between items-center mb-4 space-x-2">
        <h2 class="text-xl font-bold">الدورات</h2>
        <div class="flex space-x-2">
          <button v-if="!is_registered" @click="handleRegister"
                  class="bg-transparent border border-[#277b9d] text-[#277b9d] px-4 py-2 rounded-lg shadow-md hover:bg-[#277b9d] hover:text-white">
            التسجيل في المسار
          </button>
          <button @click="goBack"
                  class="bg-transparent border border-[#277b9d] text-[#277b9d] px-4 py-2 rounded-lg shadow-md hover:bg-[#277b9d] hover:text-white ml-2">
            العودة
          </button>
        </div>

      </div>

      <div class="grid gap-4">
        <CourseItem v-if="!is_registered" v-for="course in courses" :key="course.id" :course="course"/>
        <RegisteredProgramCourses
            v-else
            :courses="courses"
            :reloadProgram="reloadProgram"
            :redirect_to_certification="redirect_to_certification"
            :is_completed="is_completed"
            :is_not_last_viewed="is_not_last_viewed"
            :show_new_courses_msg="show_new_courses_msg"
        />
      </div>
    </main>

    <div class="modal">
      <transition
          enter-active-class="transition-opacity duration-300 ease-out"
          enter-from-class="opacity-0"
          leave-active-class="transition-opacity duration-300 ease-in"
          leave-to-class="opacity-0"
      >
        <div v-if="showModal" class="fixed inset-0 flex items-center justify-center bg-[rgba(0,0,0,0.6)] z-10">
          <div class="bg-white p-6 rounded-lg shadow-lg flex flex-col items-center fixed">
            <i class="fas fa-check-circle text-green-500 text-4xl mb-4"></i>
            <h3 class="text-md mb-10"> تم تسجيلك في مسار {{ program_name }} بنجاح</h3>
            <button @click="showModal=false"
                    class="bg-transparent border border-[#277b9d] text-[#277b9d] px-4 py-2 rounded-lg shadow-md hover:bg-[#277b9d] hover:text-white cursor-pointer">
              ابدأ الآن
            </button>
          </div>
        </div>
      </transition>
    </div>
  </div>

</template>

<script>
import CourseItem from "@/components/public_programs/CourseItem.vue";
import {getPublicProgramDetails} from "~/services/index.js";
import {registerUserProgram} from "~/services/public_program/apis.js";
import RegisteredProgramCourses from "@/components/public_programs/RegisteredProgramCourses.vue";
import TitleBanner from "~/components/header/TitleBanner.vue";


export default {
  components: {TitleBanner, RegisteredProgramCourses, CourseItem},
  data() {
    return {
      titleBanner: localStorage.getItem("tracksBannerTitle") || "",
      courses: [],
      redirect_to_certification: "",
      is_completed: false,
      is_not_last_viewed: false,
      show_new_courses_msg: false,
      showModal: false,
      is_registered: false,
      program_description: "",
      program_name: "",
      image: "",
      program_uuid: undefined
    };
  },
  mounted() {
    this.program_uuid = this.$route.params.uuid;
    this.reloadProgram();
  },
  methods: {
    reloadProgram() {
      getPublicProgramDetails(this.program_uuid).then(response => {
        this.courses = response.courses;
        this.is_registered = response.is_registered;
        this.program_description = response.program_description;
        this.program_name = response.program_name;
        this.image = response.image;
        this.redirect_to_certification = response.redirect_to_certification;
        this.is_completed = response.is_completed;
        this.show_new_courses_msg = response.show_new_courses_msg;
        this.is_logged_in = response.is_logged_in;
        this.redirect_to_nafath_login = response.redirect_to_nafath_login;
        this.is_not_last_viewed = response.is_not_last_viewed;
      });
    },

    handleRegister() {
      if (!this.is_logged_in) {
        sessionStorage.setItem('program_uuid', this.program_uuid);
        window.location.href = this.redirect_to_nafath_login
      } else {
        const program_uuid = this.$route.params.uuid;
        registerUserProgram(program_uuid).then(response => {
          this.showModal = true;
          this.reloadProgram();
        });
      }
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>

</style>